export class HtmlHelper {

    /**
     * Create a html-form with hidden elements
     *
     * @param {string} action url to sned form to
     * @param {Array} values
     * @param {string} [method='post']
     * @returns {HTMLFormElement}
     */
    public static createHiddenForm(action: string, values: { key: string, value: string }[], method: string = 'post'): HTMLFormElement {
        var f = document.createElement("form");
        f.setAttribute('method', method);
        f.setAttribute('action', action);
        f.setAttribute('enctype', 'application/x-www-form-urlencoded');

        values
            .filter(kv => kv.value !== null && kv.value !== undefined)
            .forEach(kv => {
                var i = document.createElement("input");
                i.setAttribute('type', "hidden");
                i.setAttribute('name', kv.key);
                i.setAttribute('value', encodeURIComponent(kv.value));

                f.appendChild(i);
            });

        return f;
    }

    /**
     * Appends given element to the html body
     *
     * @param {HTMLElement} element
     * @memberof HtmlHelper
     */
    public static appendToBody(element: HTMLElement): void {
        //add form and submit
        document.getElementsByTagName('body')[0].appendChild(element);
    }
}